import React from 'react';

interface ISVGProps {
	bookfill?: string;
	bookside?: string;
	bookfront?: string;
	color?: string;
	height?: string;
	width?: string;
}

type AllProps = ISVGProps;

export class YacastLogoIcon extends React.Component<AllProps> {
	render() {
		let { color } = this.props;
		if (!color) {
			color = '#FFFFFF';
		}
		return (
			<svg
				width="153"
				height="25"
				viewBox="0 0 153 25"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0)">
					<path
						d="M10.6809 0.466963L21.0027 17.4395C21.1006 17.6018 21.3365 17.6043 21.4382 17.4457L24.8165 12.2148C24.8692 12.1324 24.8704 12.0288 24.8202 11.9451L17.6972 0.161095C17.6508 0.0836919 17.5667 0.0362512 17.4751 0.0374996L10.8993 0.0799466C10.6997 0.081195 10.578 0.297175 10.6809 0.466963Z"
						fill="#C54CFB"
					/>
					<path
						d="M21.421 0.43322L26.5223 8.87267C26.6202 9.03497 26.8561 9.03871 26.959 8.87891L32.4054 0.425729C32.5146 0.255941 32.3916 0.0324707 32.1883 0.0324707L21.6393 0.0462035C21.441 0.0462035 21.3181 0.262184 21.421 0.43322Z"
						fill="#C54CFB"
					/>
					<path
						d="M14.9287 24.5505C17.982 23.0724 18.9282 21.3632 19.1729 20.7852C19.2243 20.6641 19.2143 20.5255 19.1465 20.4119L7.04398 0.225918C6.99755 0.148515 6.91347 0.101074 6.82311 0.101074H0.257308C0.057774 0.101074 -0.0652093 0.318303 0.0364402 0.48809L14.4757 24.4169C14.5698 24.5717 14.7668 24.6292 14.9287 24.5505Z"
						fill="#6561E4"
					/>
					<path
						d="M11.1084 24.9663C11.3055 24.9613 11.4209 24.7441 11.3167 24.578L6.42377 16.8415C6.32588 16.6792 6.08996 16.6754 5.98705 16.8352L1.18694 24.5855C1.08278 24.7528 1.202 24.97 1.40028 24.9713C3.05804 24.99 8.81441 25.0287 11.1084 24.9663Z"
						fill="#6561E4"
					/>
				</g>
				<defs>
					<clipPath id="clip0">
						<rect width="153" height="25" fill={color} />
					</clipPath>
				</defs>
			</svg>
		);
	}
}
